import React, { useState, useEffect } from "react";
import { ImCross } from "react-icons/im";
import { configData } from "../data/configData";
import { FaPlus } from "react-icons/fa";
import { MdOutlineEvent } from "react-icons/md";
import { GrSystem } from "react-icons/gr";
import Table from "../component/Table";
import { useNavigate, useLocation  } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const Config = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuDetailOpen, setMenuDetailOpen] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [name, setName] = useState("");
  const [fields, setFields] = useState([]);
  const [dataList, setDataList] = useState(configData);
  const [logoName, setLogoName] = useState("");
  const [logoImage, setLogoImage] = useState(null);
  const [fieldInput, setFieldInput] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [uploadedLogos, setUploadedLogos] = useState([]);
  const navigate = useNavigate();
const location = useLocation();


  const handleAddField = () => {
    if (fieldInput.trim() === "") return;
    setFields([...fields, fieldInput.trim()]);
    setFieldInput("");
  };


  useEffect(() => {
    const saved = localStorage.getItem("uploadedLogo");
    if (saved) {
      setUploadedLogos([JSON.parse(saved)]);
    }
  }, []);

   useEffect(() => {
    if (location.state?.openAddModal) {
      setMenuDetailOpen(true); 
    }
  }, [location.state]);

  return (
    <div>
      <div className=" px-5 md:px-10 mt-[5%]">
  <h4 className="text-primary font-bold text-2xl mb-4">கட்டமைப்பு</h4>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
    {/* Event Config Card */}
    <div className="rounded-xl bg-[#f1f8f6] shadow-md hover:shadow-lg transition">
      <button
        onClick={() => navigate("events")}
        className="flex items-center justify-center w-full h-full gap-2 px-8 py-6 text-[#0f316a] text-lg font-semibold"
      >
      நிகழ்வு
      </button>
    </div>

    {/* System Config Card */}
    <div className="rounded-xl bg-[#f1f8f6] shadow-md hover:shadow-lg transition">
      <button
        onClick={() => navigate("/systemConfig")}
        className="flex items-center justify-center w-full h-full gap-2 px-8 py-6 text-[#0f316a] text-lg text-nowrap font-semibold"
      >
      கணினி கட்டமைப்பு
      </button>
    </div>
  </div>
</div>


    
    </div>
  );
};

export default Config;
